export class RemoveGodkendelsePostModel {
    constructor(kursusId: string, brugerMaalbeskrivelseId?: string) {
        this.kursusId = kursusId;
        this.brugerMaalbeskrivelseId = brugerMaalbeskrivelseId;
    }

    kursusId: string;
    brugerMaalbeskrivelseId?: string;
}
